import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e3b3dbc8"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loading_element = _resolveComponent("loading-element");
  const _component_trending_popover = _resolveComponent("trending-popover");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_loading_element, {
    loading: _ctx.loading
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      id: _ctx.buildPortfolioTargetId($props.portfolio, $props.trendingType),
      class: _normalizeClass(["trending", $options.processedTrendingValue($props.portfolio?.[$data.trendingKeys[$props.trendingType]])])
    }, _toDisplayString($options.trendingValue($props.portfolio?.[$data.trendingKeys[$props.trendingType]])), 11, _hoisted_1)]),
    _: 1
  }, 8, ["loading"]), _createVNode(_component_trending_popover, {
    target: _ctx.buildPortfolioTargetId($props.portfolio, $props.trendingType),
    portfolio: $props.portfolio
  }, null, 8, ["target", "portfolio"])], 64);
}